<template>
  <v-main>
    <v-container fluid>
      <v-btn
        fab
        x-small
        class="mx-2 mb-2"
        color="white"
        @click="$router.back()"
      >
        <v-icon light>mdi-arrow-left</v-icon>
      </v-btn>
      <v-card
        elevation="10"
        align="center"
        class="mt-4 card-height"
        rounded="xl"
        :loading="isLoading"
      >
        <v-row class="ma-0 pt-2">
          <v-col class="pa-0 mt-3" cols="3">
            <span class="pr-0 pl-5" style="min-width: 126px; text-align: left"
              >Date:
            </span>
          </v-col>
          <v-col class="pa-0 mr-3 mt-1 pl-4">
            <v-dialog
              ref="VisitDate"
              :close-on-content-click="false"
              v-model="date_of_visit_menu"
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="selectedDate"
                  label="Date"
                  solo
                  dense
                  hide-details=""
                  rounded
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="selectedDate"
                scrollable
                @input="
                  () => {
                    date_of_visit_menu = false;
                    getData();
                  }
                "
              >
              </v-date-picker>
            </v-dialog>
          </v-col>
        </v-row>
        <v-row class="ma-0 pt-2">
          <v-col class="pa-0 mt-3" cols="3">
            <span class="pr-0 pl-2" style="min-width: 126px; text-align: left"
              >Site Location:</span
            >
          </v-col>
          <v-col class="pa-0 mr-3 mt-1 pl-4">
            <v-select
              solo
              dense
              rounded
              hide-details=""
              v-model="selectedSiteId"
              :items="sites"
              item-text="text"
              item-value="value"
              label="Select Site"
              @change="getData()"
              clearable
              open-on-clear
            ></v-select>
            <!-- style="max-width: 300px" -->
          </v-col>
        </v-row>
        <hr class="mt-4 mx-4" />
        <v-row class="ma-0 pt-2">
          <v-col class="pa-0 ml-5" align="left">
            <span class="pr-0" style="min-width: 156px">Site Details:</span>
          </v-col>
        </v-row>

        <template v-if="selectedSiteId">
          <v-row class="ma-0">
            <v-col align="left" style="max-width: 40px">
              <img
                :src="require('@/assets/voe_imgs/logo.jpeg')"
                alt="Site Logo"
                height="50"
                width="50"
              />
            </v-col>
            <v-col>
              <v-row class="ma-0">
                <v-col class="blue--text text-h6 font-weight-bold pa-0">
                  {{ form.name }}
                </v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col class="pa-0">
                  {{ form.site_address }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row class="mx-4 mt-2 my-2">
            <v-col class="pa-0">
              <h5 class="text-h6" align="left">Location</h5>
              <gmap-map
                :center="mapCenter"
                :zoom="15"
                style="width: 100%; height: 425px"
                :options="mapOptions"
                ref="mapRef"
              >
                <!-- Site Marker -->
                <gmap-marker
                  :position="mapCenter"
                  :clickable="true"
                  :draggable="false"
                  :icon="siteMarkerIcon"
                  :title="form.name"
                  @click="openSiteInfoWindow"
                />

                <!-- User Markers with slight offset to prevent overlap -->
                <gmap-marker
                  v-for="(user, index) in geoFenceUserData"
                  :key="index"
                  :position="getUserPosition(user)"
                  :clickable="true"
                  :draggable="false"
                  :icon="getUserMarkerIcon(user)"
                  @click="openUserInfoWindow(user, index)"
                />

                <gmap-circle
                  :center="mapCenter"
                  :radius="25"
                  :options="circleOptions"
                />

                <!-- Site Info Window -->
                <gmap-info-window
                  :position="mapCenter"
                  :opened="siteInfoWindowOpen"
                  @closeclick="siteInfoWindowOpen = false"
                >
                  <div>
                    <h3>{{ form.name }}</h3>
                    <p>{{ form.site_address }}</p>
                  </div>
                </gmap-info-window>

                <!-- User Info Window -->
                <gmap-info-window
                  :position="selectedUserPosition"
                  :opened="userInfoWindowOpen"
                  @closeclick="userInfoWindowOpen = false"
                >
                  <div v-if="selectedUser" class="user-info">
                    <v-avatar size="50">
                      <img
                        :src="
                          selectedUser.user.profile_image || defaultUserImage
                        "
                        :alt="selectedUser.user.full_name"
                        @error="onImageError"
                      />
                    </v-avatar>
                    <h3>{{ selectedUser.user.full_name }}</h3>
                    <p>Employee ID: {{ selectedUser.user.employee_id }}</p>
                    <p v-if="selectedUser.state == 'IN'">
                      Punch In: {{ selectedUser.time }}
                    </p>
                    <!-- <p v-if="selectedUser.punch_out_time">
                      Punch Out:
                      {{ selectedUser.punch_out_time }}
                    </p> -->
                  </div>
                </gmap-info-window>
              </gmap-map>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row class="mt-12" justify="center">
            <v-col class="mx-9 mt-8" align="center">
              <span class="blue--text"
                >Please select a site from the list to view its details</span
              >
            </v-col>
          </v-row>
          <v-row justify="center" class="mt-12">
            <v-col align="center" class="my-8">
              <v-img
                :src="require('../../assets/voe_imgs/new-joinee-demo.png')"
                alt="Site Location"
                width="200"
                height="180"
              ></v-img>
            </v-col>
          </v-row>
        </template>
      </v-card>
    </v-container>
    <v-container class="footer-text">
      <v-row justify="center">
        <v-col align="center">
          <h3 class="white--text">We Alliance Sparkle</h3>
          <h4 class="white--text">v 1.0.0</h4>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

import moment from "moment";

export default {
  data() {
    return {
      isLoading: false,
      selectedSiteId: "",
      sites: [],
      geoFenceUserData: [],
      form: {
        name: "",
        site_code: "",
        site_address: "",
      },
      selectedDate: moment().format("YYYY-MM-DD"),
      mapCenter: { lat: 0, lng: 0 },
      mapOptions: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false,
      },
      siteMarkerIcon: {
        url: require("@/assets/voe_imgs/logo.jpeg"),
        scaledSize: { width: 40, height: 40 },
      },
      defaultUserImage: require("@/assets/voe_imgs/profile.png"),
      siteInfoWindowOpen: false,
      userInfoWindowOpen: false,
      selectedUser: null,
      selectedUserPosition: null,

      circleOptions: {
        strokeColor: "#1976D2",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#1976D2",
        fillOpacity: 0.2,
        clickable: false,
        draggable: false,
        editable: false,
        visible: true,
      },
      date_of_visit_menu: false,
    };
  },
  mounted() {
    this.getSites();
  },
  methods: {
    async getSites() {
      try {
        this.isLoading = true;
        const response = await axios.get(`/sites`);
        const sites = response.data.data || [];
        this.sites = sites.map((site) => ({
          text: site.name,
          value: site.id,
        }));
      } catch (error) {
        console.error("Error fetching sites:", error);
        this.$toast.error("Failed to load sites");
      } finally {
        this.isLoading = false;
      }
    },
    async getData() {
      if (!this.selectedSiteId) {
        this.resetData();
        return;
      }

      this.isLoading = true;
      try {
        const response = await axios.get(
          `/getGeoFencePunchDetails?siteId=${this.selectedSiteId}&date=${this.selectedDate}`
        );

        this.geoFenceUserData = response.data.data || [];
        this.mapCenter = {
          lat: parseFloat(response.data.latitude) || 0,
          lng: parseFloat(response.data.longitude) || 0,
        };
        this.form = {
          name: response.data.name || "Unknown Site",
          site_address: response.data.address || "N/A",
        };
      } catch (error) {
        console.error("Error fetching site data:", error);
        this.$toast.error("Failed to load site data");
      } finally {
        this.isLoading = false;
      }
    },
    resetData() {
      this.geoFenceUserData = [];
      this.mapCenter = { lat: 0, lng: 0 };
      this.form = { name: "", site_address: "" };
      this.siteInfoWindowOpen = false;
      this.userInfoWindowOpen = false;
    },
    getUserPosition(user) {
      const offset = Math.random() * 0.0001;
      return {
        lat: parseFloat(user.user_latitude || user.latitude || 0) + offset,
        lng: parseFloat(user.user_longitude || user.longitude || 0) + offset,
      };
    },
    getUserMarkerIcon(user) {
      return {
        url: user.user.profile_image || this.defaultUserImage,
        scaledSize: { width: 40, height: 40 },
        anchor: { x: 20, y: 20 },
      };
    },
    openSiteInfoWindow() {
      this.siteInfoWindowOpen = true;
      this.userInfoWindowOpen = false;
    },
    openUserInfoWindow(user) {
      this.selectedUser = user;
      this.selectedUserPosition = this.mapCenter;
      this.userInfoWindowOpen = true;
      this.siteInfoWindowOpen = false;
    },
    onImageError(event) {
      event.target.src = this.defaultUserImage;
    },
    formatDateTime(dateTime) {
      return dateTime ? moment(dateTime).format("hh:mm A") : "N/A";
    },
  },
};
</script>

<style scoped>
.card-height {
  min-height: 70vh;
  max-height: 90vh;
  overflow-y: auto;
}

.user-info {
  padding: 10px;
  min-width: 200px;
}

@media (max-width: 600px) {
  .card-height {
    min-height: 75vh;
  }
}

@media (min-width: 601px) and (max-width: 960px) {
  .card-height {
    min-height: 80vh;
  }
}
</style>
